// extracted by mini-css-extract-plugin
module.exports = {"expandButton":"expand_button_expandButton__19wjM","arrowIcon":"expand_button_arrowIcon__3jJjP","arrowIconInverted":"expand_button_arrowIconInverted__33cpg"};